// extracted by mini-css-extract-plugin
module.exports = {"root":"Email_root__2RJnD","disableInset":"Email_disableInset__3Jd4Q"};